// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { EURO_TEXT } = require('constants/index');

const initialState = Immutable.fromJS({
    modalData: [],
    data: [],
    isFetching: false,
    selectedOption: EURO_TEXT,
    selectedPortfolio: '0',
    error: null,
});

const parseResponse = (state, response) => {
    return state.merge({ modalData: response, isFetching: false });
};

const parseResponseTotals = (state, response) => {
    return state.merge({ data: response, isFetching: false });
};

const RAPortfolioEvolution = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_PORTFOLIO_EVOLUTION_CHANGE_MODAL_OPTION:
            return state.merge({
                selectedPortfolio: action.payload.value,
            });
        case actionTypes.RA_PORTFOLIO_EVOLUTION_CHANGE_OPTION:
            return state.merge({ selectedOption: action.payload.value });
        case actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_REQUEST:
        case actionTypes.RA_PORTFOLIO_EVOLUTION_REQUEST:
            return state.merge({ isFetching: true, error: null });
        case actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_FAILURE:
        case actionTypes.RA_PORTFOLIO_EVOLUTION_FAILURE:
            return state.merge({ isFetching: false, error: true });
        case actionTypes.RA_PORTFOLIO_EVOLUTION_TOTALS_SUCCESS:
            return parseResponseTotals(
                state,
                action.payload.data.groupedValuations,
            );
        case actionTypes.RA_PORTFOLIO_EVOLUTION_SUCCESS:
            return parseResponse(state, action.payload.data.valuations);
        default:
            return state;
    }
};

module.exports = RAPortfolioEvolution;
